module.exports = __webpack_public_path__ + "static/media/photo32.3cbbaaaf.jpg";